import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as R from 'ramda';
import { Carousel } from 'components/carousel/carousel';
import { GamesCategories as GamesCategoriesCore, FormattedTag, RouteLink } from 'core/components';
import { withCoreComponent } from 'core/hocs';
import { GAME_CATEGORY_FILTER } from 'core/constants';
import Button from 'reactstrap/lib/Button';
import { IconCards } from 'components/icons/icon-cards/icon-cards';

import './games-categories.scss';

export const GAMES_CATEGORIES_DATA = {
  live: {
    route: '/games/live',
    categoryClass: 'live',
  },
  roulette: {
    route: '/games/roulette',
    categoryClass: 'roulette rounded',
  },
  slot: {
    route: '/games/slot',
    categoryClass: 'slot',
  },
  card: {
    route: '/games/card',
    categoryClass: 'cards',
  },
  sport: {
    route: '/games/sport',
    categoryClass: 'sport rounded',
  }
};

export const CATEGORY_IDS = {
  [GAME_CATEGORY_FILTER.ALL]: 'games.category.all',
  [GAME_CATEGORY_FILTER.RECOMMENDED]: 'games.category.recommended',
  [GAME_CATEGORY_FILTER.POPULAR]: 'games.category.popular',
  [GAME_CATEGORY_FILTER.SLOTS]: 'games.category.slot',
  [GAME_CATEGORY_FILTER.JACKPOTS]: 'games.category.jackpots',
  [GAME_CATEGORY_FILTER.LIVE_CASINO]: 'games.category.live',
  [GAME_CATEGORY_FILTER.NEW_GAMES]: 'games.category.new',
  [GAME_CATEGORY_FILTER.BLACKJACK]: 'games.category.blackjack',
  [GAME_CATEGORY_FILTER.ROULETTE]: 'games.category.roulette',
  [GAME_CATEGORY_FILTER.CARD_GAMES]: 'games.category.card',
  [GAME_CATEGORY_FILTER.SPORT]: 'games.category.sport',
};

export const carouselSettings = {
  arrows: true,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 719,
      settings: {
        arrows: false,
        slidesToShow: 1.51,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1279,
      settings: {
        arrows: false,
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 9999,
      settings: {
        arrows: true,
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
  ],
};

export class GamesCategoriesUI extends Component {
  static propTypes = {
    categories: PropTypes.shape({}).isRequired,
    className: PropTypes.string,
  };

  static defaultProps = {
    className: null,
  };

  state = {
    isMounted: false,
  };

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  render() {
    const { categories, className } = this.props;
    const { isMounted } = this.state;
    const gamesCategories = Object.entries(categories).map(([title, count]) => ({ title, count }));

    return (
      <div className={className}>
        <div className="d-flex justify-content-between align-items-center mb-1_5 mb-md-2">
          <div className="d-flex align-items-center">
            <IconCards className="icon-games-categories" />
            <FormattedTag id="games.categories" className="ml-1 text-large font-weight-bold" />
          </div>
          <Button color="link" className="d-flex align-items-center mr-lg-1 py-0">
            <FormattedTag id="games.category.all" tag={RouteLink} to="/games" className="text-base" />
          </Button>
        </div>

        {isMounted
          ? (
            <div className="d-flex flex-column justify-content-between games-categories">
              <Carousel settings={carouselSettings}>
                {gamesCategories.map(({ title, count }) => {
                  const { route, categoryClass } = GAMES_CATEGORIES_DATA[title];

                  return (
                    <RouteLink key={title} to={route} className="text-white rounded" draggable="false">
                      <div className={classNames('w-100 position-relative games-categories-card bg-gray rounded d-flex align-items-end pb-1_75 px-2', categoryClass)}>
                        <div className={classNames('w-100 position-absolute games-categories-outer-image', categoryClass)} />

                        <div className="w-100 d-flex games-categories-card-text justify-content-between align-items-end">
                          <div className="w-100 d-flex text-center justify-content-between align-items-center">
                            <FormattedTag id={`games.category.${title}`} className="h4 font-weight-semi-bold" />
                            <span className="d-flex flex-grow-0 flex-column pl-2 border-left dashed-0_4">
                              <span className="h5 font-weight-medium line-height-09">{count}</span>

                              <FormattedTag id="games" className="h6 font-weight-medium text-lowercase" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </RouteLink>
                  );
                })}
              </Carousel>
            </div>
          )
          : (
            <div className="games-categories-preloader mr-n2 mr-sm-n2_5 mr-lg-n0">
              {R.times(i => <div key={i} className="games-categories-preloader-item preloader rounded" />, 5)}
            </div>
          )}
      </div>
    );
  }
}

export const GamesCategories = withCoreComponent(GamesCategoriesCore, GamesCategoriesUI);
